import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledIconContainer,
	StyledInfoContainer,
	StyledTopContainer,
	StyledProgressWrapper,
	StyledProgress,
} from './VehicleStateItem.styled';

const VehicleStateItem = ({
	name,
	percent,
	icon,
}: {
	name: string;
	percent: number;
	icon: string;
}) => {
	return (
		<StyledContainer>
			<StyledIconContainer>
				<img src={icon} />
			</StyledIconContainer>
			<StyledInfoContainer>
				<StyledTopContainer>
					<TextLabel>{name}</TextLabel>
					<TextLabel
						style={{ color: percent <= 30 ? '#C71E1E' : '#FFFFFF' }}
					>{`${percent}%`}</TextLabel>
				</StyledTopContainer>
				<StyledProgressWrapper>
					<StyledProgress
						style={{
							width: `${percent}%`,
							backgroundColor: percent <= 30 ? '#C71E1E' : '#2D70DA',
						}}
					/>
				</StyledProgressWrapper>
			</StyledInfoContainer>
		</StyledContainer>
	);
};

export { VehicleStateItem };
